import { render, staticRenderFns } from "./Emailopen.vue?vue&type=template&id=037fc8f1&scoped=true&"
import script from "./Emailopen.vue?vue&type=script&lang=ts&"
export * from "./Emailopen.vue?vue&type=script&lang=ts&"
import style0 from "./Emailopen.vue?vue&type=style&index=0&id=037fc8f1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037fc8f1",
  null
  
)

export default component.exports